export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading: (state) => {
      return state.loading;
    },
  },
  mutations: {
    start_loading(state) {
      state.loading = true;
    },
    end_loading(state) {
      state.loading = false;
    },
  },
};
